export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/debt.6907e216.svg","height":165,"width":166,"blurWidth":0,"blurHeight":0};